var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImgProfessionista(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.903,
    height: 102.423,
    viewBox: "0 0 50.903 102.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor_1",
    transform: "translate(-201.202 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5",
    "data-name": "Raggruppa 5",
    transform: "translate(203.009 22.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M228.256,291.9c-3.174,1.333-10.963,3.137-12.561,9.981s2.347,54.287,2.347,54.287h41.867s3.61-44.925,2.374-53.588c-.869-6.087-11.611-10.367-14.556-10.89S231.948,290.35,228.256,291.9Z",
    transform: "translate(-215.314 -275.75)",
    fill: "#faede8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M261.981,522.4c-11.776,1.57-23.16-1.57-34.938,1.57a11.7,11.7,0,0,1-8.5-.837c.252,5.149.589,10.63.928,15.666a5.524,5.524,0,0,0,6.4.874,131.331,131.331,0,0,0,12.169-7.066c6.866,1.81,21.365,14.142,26.106,4.933.329-5.131.649-10.648.877-15.755A8.209,8.209,0,0,1,261.981,522.4Z",
    transform: "translate(-218.127 -476.981)",
    fill: "#dbd0cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    transform: "translate(13.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M325.109,175.977s.2,7.6,0,9.55-4.909,2.623-4.909,2.623c6.254,10.962,12.286,11.095,18.892,0,0,0-5.038-.269-5.24-2.555s-.068-9.616-.068-9.616c0-5.468-8.675-5.468-8.675,0Z",
    transform: "translate(-320.2 -171.876)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M362.068,183.534a4.812,4.812,0,0,0,5.1-2.278c-.005-2.619.044-5.288.044-5.288,0-5.468-8.675-5.468-8.675,0,0,0,.073,2.772.087,5.4A6.172,6.172,0,0,0,362.068,183.534Z",
    transform: "translate(-353.631 -171.867)",
    fill: "#df9a85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M321.428,266.68l4.948,3.956,4.553-3.838a13.027,13.027,0,0,0,1.466,2.805,30.218,30.218,0,0,0,3.476.88,69.458,69.458,0,0,1-9.463,17.5A78.465,78.465,0,0,1,316.4,270.692a37.009,37.009,0,0,0,3.895-1.13,14.452,14.452,0,0,0,1.134-2.882Z",
    transform: "translate(-303.458 -254.541)",
    fill: "#d2dcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M376.656,303.781l-2.408,2.932,1.361,1.361-1.469,8.556a21.133,21.133,0,0,0,2.614,3.705,19.889,19.889,0,0,0,2.517-3.705l-1.883-8.3,1.571-1.571-2.3-2.984Z",
    transform: "translate(-353.806 -286.891)",
    fill: "#6c724e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M350.033,298.244a.194.194,0,0,1-.165-.091,38.57,38.57,0,0,1-2.518-4.635.2.2,0,0,1,.357-.163,38.342,38.342,0,0,0,2.493,4.587.2.2,0,0,1-.165.3Z",
    transform: "translate(-330.43 -277.701)",
    fill: "#6c724e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M416.32,296.764a.2.2,0,0,1-.105-.031.2.2,0,0,1-.061-.27,48.811,48.811,0,0,0,2.669-4.82.2.2,0,0,1,.262-.091.2.2,0,0,1,.092.262,49.053,49.053,0,0,1-2.691,4.859.2.2,0,0,1-.166.092Z",
    transform: "translate(-390.414 -276.211)",
    fill: "#6c724e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(10.153 16.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M294.811,307.819a.2.2,0,0,1-.2-.213,12.293,12.293,0,0,1,.917-3.819.2.2,0,0,1,.362.154,11.72,11.72,0,0,0-.862,3.43,13,13,0,0,1,3.1-.285.2.2,0,0,1,.191.2.206.206,0,0,1-.2.191,12.561,12.561,0,0,0-3.263.335.185.185,0,0,1-.045.005Z",
    transform: "translate(-294.615 -303.668)",
    fill: "#899b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M309.4,342.89a.2.2,0,0,1-.143-.061,31.76,31.76,0,0,0-10.681-6.775.2.2,0,0,1-.12-.224,19.322,19.322,0,0,1,1.672-5.193.2.2,0,1,1,.342.192,18.533,18.533,0,0,0-1.594,4.92,32.11,32.11,0,0,1,10.669,6.811.2.2,0,0,1-.143.332Z",
    transform: "translate(-297.963 -327.096)",
    fill: "#899b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "translate(24.109 16.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M469.07,307.817a.171.171,0,0,1-.045-.005,12.556,12.556,0,0,0-3.263-.335.2.2,0,0,1-.2-.191.2.2,0,0,1,.191-.2,13,13,0,0,1,3.1.285,11.72,11.72,0,0,0-.862-3.43.2.2,0,0,1,.362-.154,12.22,12.22,0,0,1,.917,3.819.2.2,0,0,1-.2.213Z",
    transform: "translate(-457.63 -303.666)",
    fill: "#899b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M403.821,342.881a.2.2,0,0,1-.143-.332,32.13,32.13,0,0,1,10.669-6.811,18.52,18.52,0,0,0-1.594-4.92.2.2,0,1,1,.342-.192,19.355,19.355,0,0,1,1.672,5.193.2.2,0,0,1-.12.224,31.754,31.754,0,0,0-10.681,6.775.2.2,0,0,1-.143.061Z",
    transform: "translate(-403.624 -327.087)",
    fill: "#899b3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_6",
    "data-name": "Raggruppa 6",
    transform: "translate(201.202 43.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M208.346,338.019c-1.918-3.635-7.707,5.5-7.1,14.867.325,5.01-.228,14.654,3.217,20.748s14.177,1.325,11.13-8.479-4.731-22.365-7.248-27.134Z",
    transform: "translate(-201.202 -337.203)",
    fill: "#faede8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M262.914,369.581a.2.2,0,0,1-.187-.138c-1.328-4.272-2.375-8.966-3.386-13.5-1.307-5.862-2.436-10.925-3.847-13.6a.2.2,0,1,1,.347-.183c1.434,2.718,2.568,7.8,3.883,13.7,1.01,4.531,2.056,9.217,3.379,13.474a.2.2,0,0,1-.129.246.188.188,0,0,1-.059.009Z",
    transform: "translate(-248.522 -341.433)",
    fill: "#899b3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M396.188,450.338s3.886-2.22,5.481-2.845,7.91,3.123,8.674,3.677.9,4.233.9,4.233.152,4.2,0,4.718c-.264.9-1.137.25-1.179,0-.467.492-.946.636-1.457-.209-.486.262-1.069.174-1.28-.694a33.076,33.076,0,0,1-.375-3.43c-2.087-1.786-2.993.029-4.728-2.4-2.22,1.666-3.539,2.567-3.539,2.567a3.079,3.079,0,1,1-2.5-5.62Z",
    transform: "translate(-168.288 -390.143)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7",
    "data-name": "Raggruppa 7",
    transform: "translate(235.666 42.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M478.3,332.917c1.95-3.694,9.108,5.271,8.49,14.787-.33,5.09-1.043,15.212-4.545,21.406s-14.407,1.347-11.31-8.618S475.741,337.764,478.3,332.917Z",
    transform: "translate(-470.387 -332.067)",
    fill: "#faede8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M473.318,365.143a.2.2,0,0,1-.188-.255c1.344-4.325,2.406-9.086,3.432-13.69,1.335-5.987,2.489-11.156,3.946-13.919a.2.2,0,0,1,.347.183c-1.434,2.717-2.581,7.862-3.91,13.822-1.029,4.612-2.092,9.381-3.441,13.722a.2.2,0,0,1-.187.138Z",
    transform: "translate(-472.771 -336.521)",
    fill: "#899b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8",
    "data-name": "Raggruppa 8",
    transform: "translate(215.247 61.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M340.177,487.722c7,2.3,6.932,17.555-2.546,14.245-8.636-3.015-25.191-10.359-25.191-10.359L315.3,481.7S333.8,485.624,340.177,487.722Z",
    transform: "translate(-312.243 -481.504)",
    fill: "#faede8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M358.284,486.582a.172.172,0,0,1-.061-.01c-6.293-2.07-24.678-5.978-24.862-6.016a.2.2,0,0,1-.151-.233.2.2,0,0,1,.233-.151c.186.04,18.591,3.951,24.9,6.028a.2.2,0,0,1-.061.383Z",
    transform: "translate(-330.349 -480.168)",
    fill: "#899b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M336.288,568.319a.2.2,0,0,1-.065-.012c-8.543-2.983-25.041-10.291-25.206-10.364a.2.2,0,0,1,.159-.359c.165.073,16.648,7.375,25.177,10.352a.2.2,0,0,1-.065.382Z",
    transform: "translate(-310.9 -547.659)",
    fill: "#899b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9",
    "data-name": "Raggruppa 9",
    transform: "translate(203.71 56.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21",
    "data-name": "Tracciato 21",
    d: "M224.192,455.643c-6.4,3.65-3.3,18.583,5.33,13.453,7.862-4.673,22.627-15.164,22.627-15.164l-4.77-9.143s-1.7.738-4.535,1.995c-5.2,2.307-14.647,6.575-18.653,8.858Z",
    transform: "translate(-220.788 -444.594)",
    fill: "#faede8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M246.045,454.506a.2.2,0,0,1-.1-.366c5.773-3.292,23.032-10.786,23.205-10.862a.2.2,0,1,1,.156.36c-.174.076-17.413,7.563-23.167,10.843A.191.191,0,0,1,246.045,454.506Z",
    transform: "translate(-242.64 -443.262)",
    fill: "#899b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M287.673,530.214a.2.2,0,0,1-.1-.365c7.766-4.615,22.465-15.051,22.612-15.156a.2.2,0,1,1,.228.32c-.148.1-14.86,10.548-22.639,15.173A.194.194,0,0,1,287.673,530.214Z",
    transform: "translate(-278.938 -505.516)",
    fill: "#899b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10",
    "data-name": "Raggruppa 10",
    transform: "translate(207.743 56.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M257.622,439.082a14.534,14.534,0,0,0-3.357.917c-.5.42-3.156,3.558-1.361,4.034-.382,1.026.136,1.509,1.127,1.775-.426,1.132.456,1.616,1.5,1.564-.022.631.576,1.115,2.1.585,0,0,4.6-2.207,5.2-2.571,1.214-.737-.475-2.176-1-1.833-.131-1.029-.562-1.646-1.412-1.69-.3-.83-.718-1.461-1.639-1.214a1.081,1.081,0,0,0-1.151-1.567Z",
    transform: "translate(-252.29 -439.046)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M283.295,478.813a.194.194,0,0,1-.145-.064.2.2,0,0,1,.013-.278,13.672,13.672,0,0,1,5.015-2.508.2.2,0,0,1,.125.373,13.387,13.387,0,0,0-4.875,2.426.192.192,0,0,1-.132.051Z",
    transform: "translate(-279.154 -471.228)",
    fill: "#df9a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26",
    "data-name": "Tracciato 26",
    d: "M271.328,464.694a.2.2,0,0,1-.125-.045.2.2,0,0,1-.027-.276,11.557,11.557,0,0,1,5.046-3.08.2.2,0,1,1,.14.367,11.236,11.236,0,0,0-4.883,2.963.194.194,0,0,1-.151.072Z",
    transform: "translate(-268.719 -458.433)",
    fill: "#df9a85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_27",
    "data-name": "Tracciato 27",
    d: "M261.115,454.864a.2.2,0,0,1-.127-.346,15.01,15.01,0,0,1,4.7-2.705.2.2,0,0,1,.132.37,14.612,14.612,0,0,0-4.581,2.635A.2.2,0,0,1,261.115,454.864Z",
    transform: "translate(-259.814 -450.169)",
    fill: "#df9a85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_12",
    "data-name": "Raggruppa 12",
    transform: "translate(213.951 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_28",
    "data-name": "Tracciato 28",
    d: "M303.33,21.247c-3.727-8.618-3.171-12.708.41-14.686,2.072-7.289,9.725-7.983,14.43-4.646,3.971,2.817,6.138,7.221,8.522,6.282a8.111,8.111,0,0,1-3.249,6.355,29.012,29.012,0,0,1-1.652,6.777Z",
    transform: "translate(-300.782 0.003)",
    fill: "#7d5333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_11",
    "data-name": "Raggruppa 11",
    transform: "translate(0.671 6.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_29",
    "data-name": "Tracciato 29",
    d: "M308.915,150.976c-4.057-1.376-3.74,4.869.318,4.234Z",
    transform: "translate(-306.026 -138.312)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_30",
    "data-name": "Tracciato 30",
    d: "M457.2,150.976c4.057-1.376,3.74,4.869-.318,4.234Z",
    transform: "translate(-437.566 -138.312)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_31",
    "data-name": "Tracciato 31",
    d: "M342.553,69.391c-1.088,11.1-15.486,11.265-16.7,0a81.241,81.241,0,0,1,0-13.325c.428-3.7,16.092-3.384,16.7,0C343.136,59.324,342.937,65.474,342.553,69.391Z",
    transform: "translate(-323.078 -53.409)",
    fill: "#ebc3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    cx: 1.07,
    cy: 1.408,
    rx: 1.07,
    ry: 1.408,
    transform: "translate(5.435 10.514)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_2",
    "data-name": "Ellisse 2",
    cx: 1.07,
    cy: 1.408,
    rx: 1.07,
    ry: 1.408,
    transform: "translate(14.967 10.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32",
    "data-name": "Tracciato 32",
    d: "M377.159,166.845h-.028c-.318-.042-1.9-.293-1.841-1.082a5.356,5.356,0,0,1,.725-1.771.214.214,0,0,1,.364.225,4.85,4.85,0,0,0-.662,1.576c-.018.251.761.531,1.471.627a.214.214,0,0,1-.028.426Z",
    transform: "translate(-366.421 -149.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33",
    "data-name": "Tracciato 33",
    d: "M342.546,105.692a.431.431,0,0,1-.365-.661c.588-.94,1.195-1.4,1.856-1.413a2.251,2.251,0,0,1,1.785,1.228.432.432,0,0,1-.716.483c-.265-.39-.672-.858-1.054-.848-.337.006-.731.355-1.139,1.008a.433.433,0,0,1-.366.2Z",
    transform: "translate(-337.494 -97.189)",
    fill: "#7d5333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34",
    "data-name": "Tracciato 34",
    d: "M419.651,105.7a.432.432,0,0,1-.366-.2c-.408-.654-.8-1-1.139-1.008-.374-.008-.79.457-1.054.848a.432.432,0,0,1-.716-.483,2.244,2.244,0,0,1,1.785-1.228c.662.012,1.269.474,1.856,1.413a.432.432,0,0,1-.137.6.423.423,0,0,1-.228.065Z",
    transform: "translate(-402.184 -97.198)",
    fill: "#7d5333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35",
    "data-name": "Tracciato 35",
    d: "M381.888,195.744a2.629,2.629,0,0,1-1.716-.516.214.214,0,1,1,.279-.325,3.382,3.382,0,0,0,3.092.088c.7-.289,1.141-.714,1.174-1.139a.214.214,0,1,1,.428.033c-.047.6-.571,1.145-1.438,1.5a4.936,4.936,0,0,1-1.819.356Z",
    transform: "translate(-370.614 -175.698)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36",
    "data-name": "Tracciato 36",
    d: "M321.8,52.921c-.028-5.8.3-9.97,2.762-8.739,3.036-5.989,6.318,2.708,14.85,4.349,0,0,.985-5.989-.246-8.205s-16.491-2.954-17.558.41S321.8,52.921,321.8,52.921Z",
    transform: "translate(-318.569 -33.516)",
    fill: "#7d5333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImgProfessionista);
export default __webpack_public_path__ + "static/media/SvgImgProfessionista.72b031b71f65e152524d4591819604a0.svg";
export { ForwardRef as ReactComponent };